import {connect} from 'react-redux';
import Home from 'components/Home';
import { getGridFilters, getGridFilterMenus } from 'actions/homeowner/dashboard';

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
    isFetchingGridFilters: state.dashboard.fetchingGridFilters,
    isFetchingGridFilterMenus: state.dashboard.fetchingGridFilterMenus,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getGridFilters() {
    dispatch(getGridFilters("Valuation"));
  },
  getGridFilterMenus() {
    dispatch(getGridFilterMenus());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
